import { Table } from '@themesberg/react-bootstrap'
import React from 'react'

const Payments = ({
  tenantData
}) => {
  return (
    <>
      <div>
        <h4>Deposit Providers</h4>
        <Table
          bordered
          striped
          responsive
          hover
          size='sm'
          className='text-center jmt-2'
        >
          <thead className='thead-dark'>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Aggregator</th>
              <th>Group</th>
            </tr>
          </thead>

          <tbody>
            {tenantData?.depositProviders?.length > 0 &&
                    tenantData?.depositProviders?.map(
                      ({
                        name,
                        paymentProviderId,
                        aggregator,
                        group
                      }, idx) => (
                        <tr key={idx}>
                          <td>{paymentProviderId}</td>
                          <td>{name}</td>
                          <td>{aggregator}</td>
                          <td>{group}</td>
                        </tr>
                      ))}
          </tbody>
        </Table>
      </div>

      <div className='mt-3'>
        <h4>Withdraw Providers</h4>
        <Table
          
          striped
          responsive
          hover
          size='sm'
          className='text-center mt-2'
        >
          <thead className='thead-light'>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Aggregator</th>
              <th>Group</th>
            </tr>
          </thead>

          <tbody>
            {tenantData?.withdrawProviders?.length > 0 &&
                    tenantData?.withdrawProviders?.map(
                      ({
                        name,
                        paymentProviderId,
                        aggregator,
                        group
                      }, idx) => (
                        <tr key={idx}>
                          <td>{paymentProviderId}</td>
                          <td>{name}</td>
                          <td>{aggregator}</td>
                          <td>{group}</td>
                        </tr>
                      ))}
          </tbody>
        </Table>
      </div>
    </>
  )
}

export default Payments
